import { createAsyncTypes } from 'utils/ActionCreator'

export const DATA_REQUEST = createAsyncTypes('DATA_REQUEST', 'Mailboxes/Management/UserReport')
